module.exports = __webpack_public_path__ + "img/card_cramb.1981ff3a.gif";